import React, { createContext, useReducer } from "react";
import { SsdSettingsReducer } from "./SsdSettingsReducer";
import { MODAL_RESET } from "../../SettingsConstant";

export const SsdSettingsContext = createContext();

export const SsdSettingsContextProvider = (props) => {
  const settingsInsight = {
    settingsData: {
      adminSettings: {},
      showUpdatePlanResponseModal: MODAL_RESET,
      messageToDisplay: null,
    },
  };

  const [viewModel, dispatch] = useReducer(SsdSettingsReducer, settingsInsight);

  return (
    <SsdSettingsContext.Provider value={{ viewModel, dispatch }}>
      {props.children}
    </SsdSettingsContext.Provider>
  );
};

export default SsdSettingsContextProvider;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/SsdSettingsContext.js